module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAECAYAAAApgqltAAAAIklEQVQ4jWNsYWL/zzAKCAKm0SAiDowGFJFgNKCIAQwMDABAtAGU1/bqcAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/xiahua.png
// module id = qz1O
// module chunks = 1